import React, { Children, Component } from 'react';
import { createPortal } from 'react-dom';
import { animated, Transition } from '@react-spring/web';
import { arrayOf, bool, element, oneOfType, string } from 'prop-types';
import { classNames, getViewportElement } from '@philips-internal/oswald-ui-utils';
import { Backdrop } from '../backdrop/backdrop.js';
import { SlideUpPanelContainer } from './components/slide-up-panel-container.js';
import { SlideUpPanelContent } from './components/slide-up-panel-content.js';
import { SlideUpPanelFooter } from './components/slide-up-panel-footer.js';
import { SlideUpPanelHeader } from './components/slide-up-panel-header.js';
import './slide-up-panel.css';
class SlideUpPanel extends Component {
    constructor() {
        super(...arguments);
        this.closePanel = () => {
            const { onClose } = this.props;
            onClose?.();
        };
        this.handleBackdropClick = () => {
            const { closeable } = this.props;
            if (closeable) {
                this.closePanel();
            }
        };
    }
    getClassNames() {
        const { className } = this.props;
        return classNames({
            'c-slide-up-panel': true,
            [`${className}`]: Boolean(className),
        });
    }
    renderContainer() {
        const { children, closeable, open = true } = this.props;
        const childrenArray = Children.toArray(children);
        const header = childrenArray.find(child => child.type === SlideUpPanelHeader);
        const content = childrenArray.find(child => child.type === SlideUpPanelContent);
        const footer = childrenArray.find(child => child.type === SlideUpPanelFooter);
        return (React.createElement(SlideUpPanelContainer, { closeable: closeable, onClose: this.closePanel, open: open },
            header,
            content,
            footer));
    }
    renderComponent() {
        const { open = true } = this.props;
        return (React.createElement(Transition, { enter: { opacity: 1, transform: 'translate3d(0, 0, 0)' }, from: { opacity: 0, transform: 'translate3d(0, 100%, 0)' }, items: open, leave: { opacity: 0, transform: 'translate3d(0, 100%, 0)' } }, ({ opacity, transform }, item) => item ? (React.createElement(Backdrop, { className: "c-slide-up-panel__backdrop", onClick: this.handleBackdropClick, style: { opacity } },
            React.createElement(animated.div, { className: this.getClassNames(), onClick: (event) => event.stopPropagation(), role: "dialog", style: { transform } }, this.renderContainer()))) : null));
    }
    render() {
        return createPortal(this.renderComponent(), getViewportElement());
    }
}
SlideUpPanel.Content = SlideUpPanelContent;
SlideUpPanel.Footer = SlideUpPanelFooter;
SlideUpPanel.Header = SlideUpPanelHeader;
SlideUpPanel.propTypes = {
    children: oneOfType([element, arrayOf(element)]),
    className: string,
    closeable: bool,
    open: bool,
};
SlideUpPanel.defaultProps = {
    closeable: false,
    open: true,
};
export { SlideUpPanel, };
export default SlideUpPanel;
//# sourceMappingURL=slide-up-panel.js.map